import React, { useEffect, useState } from 'react';
import axios from 'axios';
import AppStrings from '../config/appstring';

const PaymodeMast = ({user}) => {
  const [data, setData] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [search, setSearch] = useState('');
  const [feeDetails, setFeeDetails] = useState([]);
  const [admissionDate, setAdmissionDate] = useState(new Date().toISOString().split('T')[0]);
  const [name, setName] = useState('');


  useEffect(() => {
   
console.log("Logged in as:", user?.name);
    fetchStudentData();
  }, [user]);


  

  const fetchStudentData = async () => {
    try {
      const response = await axios.get(AppStrings.StudentNewList);
      const result = response.data.data.result || response.data.data;

      if (Array.isArray(result)) {
        setData(result);
        setError('');
      } else {
        setError('Unexpected response format');
        console.warn('Expected an array but got:', result);
      }
    } catch (err) {
      setError('Failed to fetch data');
      console.error("Fetch error:", err.message || err);
    } finally {
      setLoading(false);
    }
  };

  const handlePayClick = async (row) => {
    const feeType = row.ADDFEES;
    const className = row.CLASS;
    const type = 'N';
    const AdmissionID=row.STUDENT_ID

    if (!feeType || !className) {
      alert('Missing class or fee type for this student.');
      return;
    }

    //const url = `https://school.agnisofterp.com/agni/fees/list?TYPE=${type}&CLASS=${className}&FEESTYPE=${feeType}`;
    const url = AppStrings.FeesDetailGet+`?TYPE=${type}&CLASS=${className}&FEESTYPE=${feeType}&ADMISSIONID=${AdmissionID}`;

    try {
      const response = await axios.get(url);
      const result = response.data.data.result || response.data.data;

      if (Array.isArray(result)) {
        const withEditable = result.map(item => ({ ...item, current: '', discount: '' }));
        setSelectedRow(row);
        setFeeDetails(withEditable);
      } else {
        alert(`No fee records found for ${row.NAME}`);
        setFeeDetails([]);
      }
    } catch (error) {
      console.error("Error fetching fee details:", error);
      alert("Failed to fetch fee details.");
    }
  };

  const handleInputChange = (index, field, value) => {
    const updated = [...feeDetails];
    updated[index][field] = value;
    setFeeDetails(updated);
  };

  const handleCancel = () => {
    setSelectedRow(null);
    setFeeDetails([]);
  };

  const totalPaid = feeDetails.reduce((sum, fee) => sum + (parseFloat(fee.current) || 0), 0);


  //  const [firstName, setFirstName] = useState("");
  //       const [lastName, setLastName] = useState("");

  const handleAddNew = () => {
  setSelectedRow({
    STUDENT_ID: '',
    NAME: '',
    CLASS: '',
    ADDFEES: '',
  });
  setFeeDetails([]);
};
        
    const handleSubmit = async () => {
      const payload = {
        student: {
          Name: name,
          Act: formData.SHIFT,
        },
      };
  
      try {
        console.log(payload,'NameList');
        //const res = await fetch("https://school.agnisofterp.com/agni/testing/entry", {
          const res = await fetch(AppStrings.StudentFeesEntry, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        });
  
        const result = await res.json();
        console.log('haiiii22');
        alert(result.message || "Data saved successfully!");
        handleCancel();
        fetchStudentData();
        console.log('haiiii33');
      } catch (err) {
        console.error("Error:", err);
        alert("Failed to save data.");
      }
    };

    const [formData, setFormData] = useState({
  SHIFT: 'Y' // default to 'Yes'
});
    const handleShiftChange = (e) => {
  setFormData(prev => ({ ...prev, SHIFT: e.target.value }));
};

  return (
    <div style={{ padding: '0px' }}>
      <h2>Paymode List</h2>

      {loading && <p>Loading data...</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}

      <div className="row">
        <div className="col-25">
          <div className="coolinput">
            <input
              type="text"
              placeholder="Search By Pay Mode"
              name="STUDENTNAME"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              autoComplete="off"
              className="input"
            />
            <br />
          </div>
        </div>
         <div className="col-75">
        <div style={{ textAlign: 'right' }}>
             <button  onClick={handleAddNew} style={MastAddNewBtn}>Add New</button>
            <br />
          </div>
        </div>
      </div>

      {!loading && !error && Array.isArray(data) && (
        <div style={{ maxHeight: 'calc(100vh - 240px)', overflowY: 'auto', border: '1px solid #ccc' }}>
    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ backgroundColor: '#f2f2f2' }}>
                <th style={{ ...headerCellStyle, width: '100px' }}>ID</th>
                <th style={{ ...headerCellStyle, width: '300px' }}>Name</th>
                <th style={{ ...headerCellStyle, width: '300px' }}>Active</th>
                <th style={headerCellStyle}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {data
                .filter((row) =>
                  row.NAME.toLowerCase().includes(search.toLowerCase()) ||
                  row.STUDENT_ID.toLowerCase().includes(search.toLowerCase())
                )
                .map((row, index) => (
                  <tr key={index}>
                    <td style={cellStyle}>{row.STUDENT_ID}</td>
                    <td style={cellStyle}>{row.NAME}</td>
                    <td style={cellStyle}>{row.NAME}</td>
                    <td style={cellStyle}>
                      <button className="GridButton" onClick={() => handlePayClick(row)}>Pay</button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      )}

      {selectedRow && (
        <div style={modalOverlayStyle}>
          <div style={modalStyle}>
           
            <div style={{ marginTop: '15px', textAlign: 'left', fontWeight: 'bold', fontSize: '16px' }}>
            <div className="row">
        <div className="col-25">
        <div className="col-25">
         <label style={{backgroundColor:'white'}} for="input" class="text">Paymode</label>
            <div className="coolinput">
           <input style={{backgroundColor:'white'}}
              type="text"
              name="STUDENTNAME"
            value={name}
  onChange={(e) => setName(e.target.value)}
              autoComplete="off"
              className="input"
            />
            
            </div> 
          </div> 
           <div className="col-75">
        <label style={{backgroundColor:'white'}} for="input" class="text">Active</label>
            <div className="coolinput">
                
                  <label style={{ marginRight: '10px' }}>
              <input
                type="radio"
                name="SHIFT"
                value="Y"
                checked={formData.SHIFT === "Y"}
             onChange={handleShiftChange}
              />
              Yes
            </label>
            <label>
              <input
                type="radio"
                name="SHIFT"
                value="N"
                checked={formData.SHIFT === "N"}
                onChange={handleShiftChange}
              />
              No
            </label>

            
            </div> 
          </div> 
          </div>
          </div>
                </div>
            {/* {feeDetails.length > 0 ? (
              <table style={{ width: '100%', marginTop: '10px',overflowY: 'auto', border: '1px solid #ccc',borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    <th style={headerCellStyle}>Fee Type</th>
                    <th style={headerCellStyle}>Fee Amount</th>
                    <th style={headerCellStyle}>Discount</th>
                    <th style={headerCellStyle}>Paid</th>
                  </tr>
                </thead>
                <tbody>
                  {feeDetails.map((fee, idx) => {
                    const feeAmount = parseFloat(fee.FEES) || 0;
                    const discount = parseFloat(fee.discount) || 0;
                    const payable = feeAmount - discount;

                    return (
                      <tr key={idx}>
                        <td style={cellStyle}>{fee.TYPE}</td>
                        <td style={cellStyle}>{fee.FEES}</td>
                        <td style={cellStyle}>
                        <div class="coolinput">
                          <input
                            type="text"
                            placeholder="Enter Discount"
                            value={fee.discount}
                            onChange={(e) => handleInputChange(idx, 'discount', e.target.value)}
                            className="input"
                          />
                          </div>
                        </td>
                        <td style={cellStyle}>
                        <div class="coolinput">
                          <input
                            type="text"
                            placeholder="Enter Paid Amount"
                            value={fee.current}
                            onChange={(e) => handleInputChange(idx, 'current', e.target.value)}
                            className="input"
                          />
                          </div>
                          <div style={{ fontSize: '0.8em', color: '#555' }}>
                            Payable: ₹{payable.toFixed(2)}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            
            ) : (
              <p>No fee data available.</p>
            )} */}
          
                <button onClick={handleSubmit} style={{ marginTop: '15px' }}>Save</button>
            <button onClick={handleCancel} style={{ marginTop: '15px' }}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

// Styles
const MastAddNewBtn=
{
    padding:10,
    backgroundColor:"#f0fc9f",
    color:'black'
}
const headerCellStyle = {
  border: '1px solid #ddd',
  padding: '8px',
  backgroundColor: '#f2f2f2',
  position: 'sticky',
  top: 0,
  zIndex: 1,
};

const cellStyle = {
  border: '1px solid #ddd',
padding: '2px',
  fontSize:'13px'
};

const modalOverlayStyle = {
  position: 'fixed',
  top: 0, left: 0, right: 0, bottom: 0,
  backgroundColor: 'rgba(0,0,0,0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 9999,
};

const modalStyle = {
  backgroundColor: 'white',
  padding: '20px',
  borderRadius: '8px',
  width: '700px',
  boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
  textAlign: 'center',
};

export default PaymodeMast;
